require('cloudinary-jquery-file-upload');
require('blueimp-file-upload');

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    "form",
    "sendButton",
    "requiredFile"
  ]

  connect() {
    $.cloudinary.config({
      cloud_name: window.cloudinary_cloud_name,
      secure: true
    });

    if ($.fn.cloudinary_fileupload !== undefined) {
      $("input.cloudinary-fileupload[type=file]").cloudinary_fileupload();
    }

    this.bindFormEvents();
    this.bindUploadEvents();
  }

  bindFormEvents () {
    this.formTarget.addEventListener('submit', function (e) {
      if (!this._allRequiredFilesPresent()) {
        e.preventDefault()
      }
    }.bind(this))
  }

  bindUploadEvents() {
    $('.cloudinary-fileupload').on('fileuploaddone', function(e, data) {
      let fileInput = e.currentTarget

      let file = data.result;
      let extension = file.format ? file.format : file.public_id.split(".").pop()
      let fileName = `${file.original_filename}.${extension}`;

      this._hideInvalidFileFeedback(fileInput)

      let link = this._createFileLink(file.url, fileName)
      this._updateAttachments(fileInput, link)
      this._addFileNameInput(fileInput, fileName)

      this.sendButtonTarget.disabled = false
    }.bind(this));

    $('.cloudinary-fileupload').on('fileuploadsend', function (e) {
      e.currentTarget.parentNode.getElementsByClassName("js-error-message")[0].classList.add("d-none")
      e.currentTarget.parentNode.getElementsByClassName("js-loading-indicator")[0].classList.remove("d-none")
      this.sendButtonTarget.disabled = true
    }.bind(this));

    $('.cloudinary-fileupload').on('fileuploadfail', function (e) {
      e.currentTarget.parentNode.getElementsByClassName("js-error-message")[0].classList.remove("d-none")
    }.bind(this));

    $('.cloudinary-fileupload').on('cloudinaryalways', function (e) {
      e.currentTarget.parentNode.getElementsByClassName("js-loading-indicator")[0].classList.add("d-none")
    }.bind(this));
  }

  _createFileLink (url, fileName) {
    let linkContainer = document.createElement("div");
    let link = document.createElement("a");

    link.setAttribute("href", url)
    link.setAttribute("target", "_blank")
    link.innerText = fileName
    link.textContent = fileName
    linkContainer.appendChild(link)

    return linkContainer;
  }

  _updateAttachments (fileInput, link) {
    let attachments = fileInput.parentNode.getElementsByClassName("js-attachments")[0]

    if (fileInput.getAttribute("multiple") !== null) {
      attachments.appendChild(link);
    } else {
      while (attachments.lastElementChild) {
        attachments.removeChild(attachments.lastElementChild);
      }

      attachments.appendChild(link);
    }
  }

  _addFileNameInput (fileInput, fileName) {
    let input = document.createElement("input");
    let name = fileInput.dataset.cloudinaryFieldName

    input.setAttribute("type", "hidden");
    input.setAttribute("name", name);
    input.setAttribute("value", fileName);

    this.formTarget.appendChild(input)
  }

  _allRequiredFilesPresent () {
    let requiredFilesPresent = []

    this.requiredFileTargets.forEach(function (target) {
      if (document.getElementsByName(target.dataset.cloudinaryField).length === 0) {
        requiredFilesPresent.push(false)
        this._showInvalidFileFeedback(target)
      } else {
        this._hideInvalidFileFeedback(target)
      }
    }.bind(this))

    return requiredFilesPresent.every(Boolean)
  }

  _showInvalidFileFeedback (input) {
    input.parentNode.getElementsByTagName("label")[0].classList.add("is-invalid-file")
  }

  _hideInvalidFileFeedback (input) {
    input.parentNode.getElementsByTagName("label")[0].classList.remove("is-invalid-file")
  }
}
